const initialState = {
    data: [],
  };
  
const odczytyUReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_ODCZYTY_U':
      return { ...state, data: action.payload };
    default:
      return state;
  }
};

export default odczytyUReducer;